module.exports = __webpack_public_path__ + "static/img/2_1_4.4b4032af.jpg";